module.exports = __webpack_public_path__ + "static/media/circle-checkmark.99bf16c5.svg";